export default __webpack_public_path__ + "static/media/Zone-6-Master-Plan-Type-E.480b0a84.png";